import api from '../api';

async function loginServer(username, password, tipo_app) {
    const apiUrl = process.env.REACT_APP_API_BASE_2;
    const response = await api.post(apiUrl, { username, password, tipo_app });
    return response.data;
}

export default loginServer;
